import { createUseStyles } from 'react-jss'

import { colors, desktop } from '../../theme'


export const headerHeight = '9rem'

export default createUseStyles({
  container: {
    zIndex: 5,
    width: '100%',
    paddingTop: '3.8rem',
    paddingLeft: '2.3rem',
    paddingRight: '2.3rem',
    paddingBottom: '2.3rem',
    ...desktop({
      paddingLeft: '4.3rem',
      paddingRight: '4.3rem',
    }),
    '&.header-bottom-gradient': {
      '&:after': {
        content: "''",
        width: '100%',
        height: '12px',
        position: 'absolute',
        left: 0,
        top: '100%',
        background: 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)',
      },
    },
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    minHeight: '3rem',
  },
  content: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  leftContent: {
    marginRight: 'auto',
    display: 'flex',
  },
  logo: {
    position: 'absolute!important',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    width: '16rem',
    height: '1.8rem',
    color: colors.pureBlack,
    cursor: 'pointer',
    '& svg': {
      width: '100%',
      height: 'auto',
    },
  },
  rightContent: {
    marginLeft: 'auto',
    display: 'flex',
  },
  menu: {
    width: '100%',
  },
  menuToggle: {
    cursor: 'pointer',
    color: colors.pureBlack,
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    ...desktop({
      display: 'none',
    }),
  },
})
